import { SYSTEM_STATUSES_UNMONITORED } from '@/constants'
import { SystemStatusSubcategoryEnum } from '@/enums'
import { SystemStatusSubcategoryDataType } from '@/types'

export const SYSTEM_STATUS_SUBCATEGORIES_UNMONITORED_SITES: SystemStatusSubcategoryDataType[] = [
    {
        value: SystemStatusSubcategoryEnum.UNMONITORED,
        statuses: SYSTEM_STATUSES_UNMONITORED
    }
]
